import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { compose, withState, withProps } from 'recompose';
import { withShowHide } from '@sparefoot/react-core/decorators';
import { GoogleMap, MapPin } from 'components/core/GoogleMap';
import { StreetView } from 'components/core/StreetView';
import { LoadingMask } from 'components/core/LoadingMask';
import { Tabs, Tab } from 'components/core/Tabs';
import { ImageCarousel } from 'components/facility/ImageCarousel';

import './FacilityViews.scss';

export const enhance = compose(
	withState('mapTabSelected', 'setMapTabSelected', false),
	withState('streetViewTabSelected', 'setStreetViewTabSelected', false),
	withShowHide('photoMask', true),
	withShowHide('mapMask', true),
	withShowHide('streetViewMask', true),
	withProps(({ facility }) => ({
		streetView: get(facility, 'location.streetView', { active: false }),
	})),
);

export function FacilityViews({
	facility,
	mapMaskShowing,
	onHideMapMask,
	onSetPhotoMask,
	photoMaskShowing,
	mapTabSelected,
	setMapTabSelected,
	onHideStreetViewMask,
	streetView,
	streetViewMaskShowing,
	setStreetViewTabSelected,
	streetViewTabSelected,
}) {
	return (
		<Tabs className="facility-views">
			<Tab
				title="Photos"
				className="photos-tab"
			>
				{photoMaskShowing && !!facility.images.length && (
					<LoadingMask relative />
				)}
				<ImageCarousel
					gallery
					facility={facility}
					images={facility.images}
					onLoad={onSetPhotoMask}
					size="large"
				/>
			</Tab>
			<Tab
				title="Map"
				className="map-tab"
				onSelect={setMapTabSelected}
			>
				{mapMaskShowing && <LoadingMask relative />}
				{mapTabSelected && (
					<GoogleMap
						center={facility.location}
						onLoad={onHideMapMask}
					>
						<MapPin location={facility.location} />
					</GoogleMap>
				)}
			</Tab>
			{streetView.active && (
				<Tab
					title="Street View"
					className="street-view-tab"
					onSelect={setStreetViewTabSelected}
				>
					{streetViewMaskShowing && <LoadingMask relative />}
					{streetViewTabSelected && (
						<StreetView
							latitude={streetView.latitude}
							longitude={streetView.longitude}
							pitch={streetView.pitch}
							zoom={streetView.zoom}
							yaw={streetView.yaw}
							onLoad={onHideStreetViewMask}
						/>
					)}
				</Tab>
			)}
		</Tabs>
	);
}

FacilityViews.propTypes = {
	photoMaskShowing: PropTypes.bool.isRequired,
	onSetPhotoMask: PropTypes.func.isRequired,
	mapMaskShowing: PropTypes.bool.isRequired,
	onHideMapMask: PropTypes.func.isRequired,
	onHideStreetViewMask: PropTypes.func.isRequired,
	mapTabSelected: PropTypes.bool.isRequired,
	setMapTabSelected: PropTypes.func.isRequired,
	setStreetViewTabSelected: PropTypes.func.isRequired,
	streetViewTabSelected: PropTypes.bool.isRequired,
	streetViewMaskShowing: PropTypes.bool.isRequired,
	streetView: PropTypes.shape({
		active: PropTypes.bool.isRequired,
		latitude: PropTypes.number,
		longitude: PropTypes.number,
		pitch: PropTypes.number,
		zoom: PropTypes.number,
		yaw: PropTypes.number,
	}).isRequired,
	facility: PropTypes.object.isRequired,
};

export default enhance(FacilityViews);
